import { defineStore } from 'pinia';
import { clearBodyLocks, lock, unlock } from 'tua-body-scroll-lock';

import { formatMoney } from '@/shared/utils/shopify/money-formatter';

export const useConfigStore = defineStore('config', {
  state: () => ({
    countryCode: null,
    graphqlHost: null,
    language: 'en',
    scrollableElements: [],
    lastSearch: '',
    minSearch: 3,
    pointsMultiplier: 0
  }),
  getters: {
    calculatedPoints() {
      return (value) => {
        // calculates points based on the points multiplier
        // takes product unit price in cents and returns the points calculated
        // we always round up to the next integer
        return Math.round((value * this.pointsMultiplier) / 100);
      };
    },
    formattedPrice() {
      const format = window.Hobbii?.moneyFormat;
      const currency = window.Shopify?.currency.active;
      return (value) => {
        // if a currency code requires rounding, round the amount
        // thats essentially all currencies except EUR, GBP and USD
        // some context can be found here:
        // https://hobbii.atlassian.net/wiki/spaces/TECH/pages/2609250306/Price+Calculations
        // https://hobbii.atlassian.net/wiki/spaces/TECH/pages/3082354689/Price+Rounding+Pretty+Prices
        if (currency !== 'EUR' && currency !== 'GBP' && currency !== 'USD') {
          const rounded = Math.round(value / 100) * 100;
          return formatMoney(rounded, format);
        }
        return formatMoney(value, format);
      };
    },
    isBodyScrollLocked() {
      return this.scrollableElements.length > 0;
    }
  },
  actions: {
    clearAllBodyScrollLocks() {
      clearBodyLocks();
    },
    lockBodyScroll(selector) {
      const element = selector ? document.querySelector(selector) : null;

      // Allow for elements with position:sticky with overflowType 'clip'
      lock(element, { overflowType: 'clip' });

      if (element) {
        this.scrollableElements.push(element);
      }
    },
    allowBodyScroll() {
      this.scrollableElements.forEach((el) => {
        unlock(el);
      });
      this.scrollableElements = [];
    }
  }
});
